<app-generic-card
  [title]="game.gameName"
  [description]="(game.gameDescription | truncate:300) || ''"
  [showDescription]="true"
  [showHeader]="false"
  [showFooter]="false"
>
  <div card-content>
    @if (game.thumbnailUrl) {
      <div class="mb-2">
        <img [src]="game.thumbnailUrl" [alt]="game.gameName" class="app-content-image" loading="lazy">
      </div>
    } @else {
      <div class="app-content-image-placeholder mb-2">Nessuna immagine</div>
    }
    <div>Tipo: <span class="fw-medium">{{ game.gameType }}</span></div>
    <div>Giocatori: <span class="fw-medium">{{ game.minPlayers }} - {{ game.maxPlayers }}</span></div>
    @if (game.yearPublished) {
      <div>Anno: <span class="fw-medium">{{ game.yearPublished }}</span></div>
    }
    @if (game.playingTime) {
      <div>Durata: <span class="fw-medium">{{ game.playingTime }} min</span></div>
    }
    @if (game.averageRating) {
      <div>Rating BGG: <span class="fw-medium">{{ game.averageRating | number:'1.1-2' }}</span></div>
    }
    <div>Creato da: <span class="fw-medium">{{ game.creatorName }}</span></div>
    @if (havingTables(game)) {
      <div>Usato in: <span class="fw-medium">{{ game.tablesAssociated }} {{ game.tablesAssociated > 1 ? 'Tavoli' : 'Tavolo' }}</span></div>
    } @else {
      <div>Usato in: <span class="fw-medium">0 Tavoli</span></div>
    }
  </div>

  <ng-container card-actions>
    @if (isLogged()) {
      <div class="row w-100 g-2">
        @if (isCreator(game) || isAdministrator()) {
          <div class="col-12">
            <button class="btn btn-warning w-100 text-white" (click)="editGame.emit(game)" [disabled]="!isTouchable(game)">
              <i class="bi bi-pencil me-1" aria-hidden="true"></i>Modifica
            </button>
          </div>
        }

        @if (isCreator(game) || isAdministrator()) {
          <div class="col-12">
            <button class="btn btn-danger w-100" (click)="deleteGame.emit(game)">
              <i class="bi bi-trash me-1" aria-hidden="true"></i>Elimina
            </button>
          </div>
        }
      </div>
    }
  </ng-container>
</app-generic-card>
